import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import lot from '../../Assets/lottie/right-arrow.json'
import { Player } from '@lottiefiles/react-lottie-player';

function Arrow() {
  return (
    <div>
    <Row style={{ justifyContent: "center", position: "relative" }}></Row>
      <Col md={1} style={{ paddingBottom: 2 }}>
            <Player
        src={lot}
        className="player"
        loop
        autoplay
        direction={-1}
        style={{ height: '200px', width: '200px' }}
      />
      </Col>
      <Row/>
    </div>
  )
}

export default Arrow
